import {
  AIRPLAY_EVENT_NAME,
  AIRPLAY_ATTR,
  AIRPLAY_UNAVAIL_ATTR,
  CHROMECAST_EVENT_NAME,
  CHROMECAST_EXIT_EVENT,
  CHROMECAST_ATTR,
  CHROMECAST_UNAVAIL_ATTR,
  CC_TOGGLE_EVENT_NAME,
  CC_ATTR,
} from '../constants/events';

export type EVENT_MODE = 'AIRPLAY' | 'CHROMECAST' | 'CC';

export interface EventObject {
  startEventName: string;
  stopEventName: string;
  stateAttributeName: string;
  unavailableAttribute?: string;
}

export const EVENTS_MAP: Record<EVENT_MODE, EventObject> = {
  AIRPLAY: {
    startEventName: AIRPLAY_EVENT_NAME,
    stopEventName: AIRPLAY_ATTR,
    stateAttributeName: AIRPLAY_ATTR,
    unavailableAttribute: AIRPLAY_UNAVAIL_ATTR,
  },
  CHROMECAST: {
    startEventName: CHROMECAST_EVENT_NAME,
    stopEventName: CHROMECAST_EXIT_EVENT,
    stateAttributeName: CHROMECAST_ATTR,
    unavailableAttribute: CHROMECAST_UNAVAIL_ATTR,
  },
  CC: {
    startEventName: CC_TOGGLE_EVENT_NAME,
    stopEventName: CC_TOGGLE_EVENT_NAME,
    stateAttributeName: CC_ATTR,
  },
};
